import { useTranslation } from 'react-i18next'

import { NotFoundPage } from '@ps/common-features/pages/NotFoundPage/NotFoundPage'
import { LanguageSelector } from 'src/components/language-selector/LanguageSelector'
import { NS } from 'src/constants/i18n'
import { EXTERNAL_ROUTES } from 'src/constants/routes'

export const RouteNotFound = () => {
  const { t } = useTranslation(NS.NOT_FOUND)

  return (
    <NotFoundPage
      title={t('title')}
      description={t('description')}
      primaryAction={{
        label: t('cta.label'),
        href: EXTERNAL_ROUTES.MARKETING_RESIDENTS,
      }}>
      <div className="w-full mt-10 md:mt-12">
        <LanguageSelector />
      </div>
    </NotFoundPage>
  )
}
